import React from 'react'
import { NavLink } from 'react-router-dom'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import 'intersection-observer'
import Wave from 'react-wavify'
import { enableReducedMotion } from '../../../custom_pages/Fc150YearsWidget/Fc150Years.utils'
import ReactPlayer from 'react-player'
import InView from 'react-intersection-observer'
import { getImageAttribute } from '../../../utils/extra_images.mod'
import { getCookieStatus } from '../../../../cms/blocks/cookiebar.utils.mod'


export type HeaderBlockProps<extra_images> = {
  title: string
  intro: string
  image: WordPress.MediaResponse
  primary_button_text: string
  video_url: string
  video_playing: boolean
  block_index: number
  header_kind: 'large' | 'small'
  header_type: 'home' | 'story'
  preview_video: string
  isInview: boolean
}

export type HeaderBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>


declare var Optanon;

export function HeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: setState => {

        const setBlockState = <K extends keyof HeaderBlockProps<extra_images>>(prop: K, newValue: HeaderBlockProps<extra_images>[K]) => (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>): CMSState<customBlockData, extra_images, PublicSite_CustomPageData> => {
          if (!s.blocks.has(props.block_index)) return s
          let current_block = s.blocks.get(props.block_index) as any//as CustomBlockData
          if (current_block.kind != 'headerBlock') return s
          current_block = ({
            ...current_block,
            value: {
              ...current_block.value,
              fst: {
                ...current_block.value.fst,
                [prop]: newValue
              },

            }
          })
          return ({ ...s, blocks: s.blocks.set(props.block_index, current_block) })
        }

        if (props.header_type == 'home') {
          let wavePaused: boolean = enableReducedMotion;
          const headerBlock = s.blocks && s.blocks.size > 0 && s.blocks.get(0) as any;
          if(headerBlock && headerBlock.kind == "headerBlock" && headerBlock.value.fst.video_playing == false) {
            wavePaused = true;
          }

          return <>
            <header className="home-intro">
              <div className="home-intro__inner">
                <div className="home-intro__content">
                  <div className="home-intro__text grid--gutter">
                    {props.title && <h1 className="home-intro__title typo--4xl">{props.title}</h1>}
                    {props.intro && <div dangerouslySetInnerHTML={{ __html: props.intro }} className="home-intro__intro typo--m" />}

                    {/* TODO: ADD THE VIDEO 'open' OR 'closed' TO THE STATE */}
                    <button className="home-intro__action" aria-controls="a11y-video" aria-expanded="false" onClick={() => {
                      if (getCookieStatus(4) == 'accepted') {
                        document.documentElement.classList.remove('video--closing')
                        document.documentElement.classList.add('video--opening')
                        setTimeout(() => {
                          document.documentElement.classList.add('video--open')
                        }, 1000);
                        setState(setBlockState('video_playing', true))
                      } else {
                        Optanon.ToggleInfoDisplay()
                      }
                    }}>
                      <div className="home-intro__button">
                        <div className="home-intro__blob">
                          <svg className="home-intro__icon" viewBox="0 0 26 27" width="26" height="27" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="m51.1708204 47.0854102 22.145898 11.072949c.7409678.3704839 1.0413043 1.2714934.6708204 2.0124612-.1451455.2902911-.3805293.5256748-.6708204.6708204l-22.145898 11.072949c-.7409678.3704839-1.6419773.0701474-2.0124612-.6708204-.1041416-.2082831-.1583592-.4379527-.1583592-.6708204v-22.145898c0-.8284271.6715729-1.5 1.5-1.5.2328676 0 .4625372.0542176.6708204.1583592z" fill="#fff" fillRule="evenodd" transform="translate(-49 -46)" /></svg>
                        </div>
                      </div>
                      <span className="home-intro__label typo--2xs">{props.primary_button_text ? props.primary_button_text : "Play the video"}</span>
                    </button>
                  </div>
                </div>

                
                <div className="home-intro__visual fit-object" aria-hidden="true">
                  {props?.image && props?.image?.source_url &&
                      <img className="home-intro__image" width="1920" height="1080" alt=""
                        src={getImageAttribute(props?.image, 'header_s', 'source_url')}
                        srcSet={`${getImageAttribute(props?.image, 'header_s', 'source_url')} 960w, ${getImageAttribute(props?.image, 'header_m', 'source_url')} 1280w, ${getImageAttribute(props?.image, 'header_l', 'source_url')} 1920w, ${getImageAttribute(props?.image, 'header_xl', 'source_url')} 2880w`}
                        sizes="100vw"
                      />
                    }
                  {/** Preview video played without sound */}
                  {props.preview_video && getCookieStatus(4) == 'accepted' && <ReactPlayer
                    className="home-intro__video"
                    url={props.preview_video}
                    width="560"
                    height="315"
                    playing={true}
                    muted={true}
                    controls={false}
                    loop={true}
                  />}

                  <div className="home-intro__overlay" />
                </div>
              </div>
            </header>

            <div id="a11y-video" className="home-video anim__wrap grid--gutter" aria-hidden="true">
              <div className="home-video__inner container--l">
                {/** Full video inside a collapsable container */}
                {getCookieStatus(4) == 'accepted' && props.video_url && <ReactPlayer url={props.video_url}
                  width="560"
                  height="315"
                  playing={props.video_playing}
                  muted={false}
                  controls={false}
                  loop={true}
                />}
              </div>

              <div className="home-video__waves anim__waves" aria-hidden="true">
                <Wave fill='rgb(255, 255, 255, .5)'
                  paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 60,
                    amplitude: 10,
                    speed: 0.1,
                    points: 8
                  }}
                  className="home-video__wave anim__wave"
                />
                <Wave fill='rgb(255, 255, 255, .65)'
                  paused={wavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 60,
                    amplitude: 10,
                    speed: 0.1,
                    points: 5
                  }}
                  className="home-video__wave anim__wave"
                />
              </div>

              <div className="home-video__shape anim__shape" aria-hidden="true" />
            </div>

          </>
        }

        if (props.header_type == 'story') {
          let phIsInview: boolean = props.isInview;
          let phWavePaused: boolean = enableReducedMotion;
          if(!phIsInview) {
            phWavePaused = true;
          }

          let story: WordPress.PageResponse & WordPress.EmbedData = undefined
          let taxonomy: WordPress.TaxonomyResponse = undefined
          if (public_state.Fc150YearsMainPage.state.page.page.kind == 'loaded') {
            story = public_state.Fc150YearsMainPage.state.page.page.value as unknown as WordPress.PageResponse & WordPress.EmbedData
            if (story != undefined && story._embedded != undefined && story._embedded['wp:term'] != undefined) {
              taxonomy = story._embedded['wp:term'].length > 0 ? story._embedded['wp:term'][0].length > 0 ? story._embedded['wp:term'][0][0] : undefined : undefined
            }
          }


          if (props.header_kind == 'small') {
            return (
              <InView className="page__header ph ph--small" as='header' key={`ph-${phIsInview}`} onChange={(inView) => setState(setBlockState('isInview', inView))}>
              <div className="ph__outer">
                <div className="ph__inner">
                  <div className="ph__content container--xl grid--gutter">
                    {props.title && <h1 className="ph__title typo--4xl">{props.title}</h1>}
                    <div className="ph__copy">
                      {props.intro && <div className="ph__intro typo--m" dangerouslySetInnerHTML={{ __html: props.intro }} />}
                      <div className="ph__fauxlink">
                        <span>Scroll to story</span>
                        <svg aria-hidden="true" width={13} height={7}>
                          <use xlinkHref="#chevron--down" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <footer className="ph__clickables container--xl grid--gutter">
                    <div className="themeicon themeicon--l ph__themevisual" aria-hidden="true">
                      <div className="themeicon__icon ph__themeicon">
                        <img className="themeicon__bg ph__themebg" width="320" height="180" alt=""
                          src={`/frontend/images/themes/bg--${taxonomy?.slug}-640w.jpg`}
                        />
                      </div>
                    </div>
                    
                    <div className="ph__clickable">
                        <NavLink to={`${"/" + public_state.Fc150YearsMainPage.lang}/${taxonomy?.slug}?taxonomy=${taxonomy?.id}`} className="ph__link link--arrow" exact>
                        <svg className="link__icon" aria-hidden="true" width={33} height={32}>
                          <use xlinkHref="#circled-arrow" />
                        </svg>
                        {taxonomy?.name}
                      </NavLink>
                    </div>
                  </footer>
                </div>
                <div className="ph__waves ph__waves--bottom">
                  <Wave fill='rgb(0, 148, 217, .3)'
                    paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                    options={{
                      height: 33,
                      amplitude: 50,
                      speed: 0.05,
                      points: 3
                    }}
                    className="ph__wave"
                  />
                  <Wave fill='rgb(0, 148, 217, .6)'
                    paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                    options={{
                      height: 66,
                      amplitude: 50,
                      speed: 0.05,
                      points: 3
                    }}
                    className="ph__wave"
                  />
                  <Wave fill='rgb(0, 148, 217)'
                    paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                    options={{
                      height: 99,
                      amplitude: 50,
                      speed: 0.05,
                      points: 2
                    }}
                    className="ph__wave"
                  />
                </div>
                <div className="ph__visual visual--small">
                  <div className="ph__visual-inner">
                    {props?.image && props?.image?.source_url &&
                      <div className="ph__media" aria-hidden="true">
                        <img className="ph__image" width="1110" height="496" alt={props?.image?.alt_text}
                          src={getImageAttribute(props?.image, 'story_header_s', 'source_url')}
                          srcSet={`${getImageAttribute(props?.image, 'story_header_s', 'source_url')} 555w, ${getImageAttribute(props?.image, 'story_header_m', 'source_url')} 1110w, ${getImageAttribute(props?.image, 'story_header_l', 'source_url')} 2220w`}
                          sizes="100vw"
                        />
                      </div>
                    }
                    
                    <svg aria-hidden="true" className="block__shape shape--1" height="456" viewBox="0 0 1040 456" width="1040"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="m1359.40691 364.003155c32.01572 150.267894 1.32986 260.478968-92.05758 330.63322-165.77396 124.532242-658.252447 157.063231-818.596551 88.663447-139.251598-59.402116-132.767252-285.681504-88.52943-419.30545z" fill="#fffbf7" fillRule="evenodd" opacity=".2" transform="translate(-332 -363)" />
                    </svg>
                    <svg aria-hidden="true" className="block__shape shape--2" height="431" viewBox="0 0 974 431" width="974"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="m1274.62431 363.998865c37.02737 172.796472 3.10601 291.518497-101.76408 356.168579-163.77976 100.966585-623.116599 91.039887-766.298695 15.266085-117.388447-62.123473-102.332218-250.329309-56.69549-371.434664z" fill="#fffbf7" fillRule="evenodd" opacity=".2" transform="translate(-316 -364)" />
                    </svg>
                    <svg aria-hidden="true" className="block__shape shape--3" height="433" viewBox="0 0 970 433" width="970"
                      xmlns="http://www.w3.org/2000/svg">
                      <path d="m1294.59329 364.002989c43.46654 154.142957 16.50539 264.391331-80.88346 330.745123-156.43481 106.58348-615.35772 128.004482-763.416244 65.869207-139.839329-58.68595-115.84935-287.592248-63.056333-396.627759z" fill="#fffbf7" fillRule="evenodd" opacity=".2" transform="translate(-345 -363)" />
                    </svg>
                  </div>
                </div>
              </div>
            </InView>
            )
          }
          return (
            <InView className="page__header ph ph--large" as='header' key={`ph-${phIsInview}`} onChange={(inView) => setState(setBlockState('isInview', inView))}>
            <div className="ph__outer">
              <div className="ph__waves ph__waves--top">
                <Wave fill='rgb(0, 148, 217, .3)'
                  paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 33,
                    amplitude: 50,
                    speed: 0.05,
                    points: 3
                  }}
                  className="ph__wave"
                />
                <Wave fill='rgb(0, 148, 217, .6)'
                  paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 66,
                    amplitude: 40,
                    speed: 0.05,
                    points: 3
                  }}
                  className="ph__wave"
                />
                <Wave fill='rgb(0, 148, 217)'
                  paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 99,
                    amplitude: 30,
                    speed: 0.05,
                    points: 2
                  }}
                  className="ph__wave"
                />
              </div>
              <div className="ph__inner">
                <div className="ph__content container--xl grid--gutter">
                  {props.title && <h1 className="ph__title typo--4xl">{props.title}</h1>}
                  <div className="ph__copy">
                    {props.intro && <div className="ph__intro typo--m" dangerouslySetInnerHTML={{ __html: props.intro }} />}
                    <div className="ph__fauxlink">
                      <span>Scroll to story</span>
                      <svg aria-hidden="true" width={13} height={7}>
                        <use xlinkHref="#chevron--down" />
                      </svg>
                    </div>
                  </div>
                </div>
                <footer className="ph__clickables container--xl grid--gutter">
                  <div className="themeicon themeicon--l ph__themevisual" aria-hidden="true">
                    <div className="themeicon__icon ph__themeicon">
                      <img className="themeicon__bg ph__themebg" width="320" height="180" alt=""
                        src={`/frontend/images/themes/bg--${taxonomy?.slug}-640w.jpg`}                        
                      />
                    </div>
                  </div>

                  <div className="ph__clickable">
                      <NavLink to={`${"/" + public_state.Fc150YearsMainPage.lang}/${taxonomy?.slug}?taxonomy=${taxonomy?.id}`} className="ph__link link--arrow" exact>
                      <svg className="link__icon" aria-hidden="true" width={33} height={32}>
                        <use xlinkHref="#circled-arrow" />
                      </svg>
                      {taxonomy?.name}
                    </NavLink>
                  </div>
                </footer>
              </div>
              <div className="ph__waves ph__waves--bottom">
                <Wave fill='rgb(0, 148, 217, .3)'
                  paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 33,
                    amplitude: 50,
                    speed: 0.05,
                    points: 3
                  }}
                  className="ph__wave"
                />
                <Wave fill='rgb(0, 148, 217, .6)'
                  paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 66,
                    amplitude: 40,
                    speed: 0.05,
                    points: 3
                  }}
                  className="ph__wave"
                />
                <Wave fill='rgb(0, 148, 217)'
                  paused={phWavePaused} // PAUSED WHEN NOT IN VIEW!
                  options={{
                    height: 99,
                    amplitude: 30,
                    speed: 0.05,
                    points: 2
                  }}
                  className="ph__wave"
                />
              </div>
              <div className="ph__visual visual--full fit-object">
                {props?.image && props?.image?.source_url &&
                  <img className="ph__image" width="1920" height="1080" alt={props?.image?.alt_text}
                    src={getImageAttribute(props?.image, 'header_s', 'source_url')}
                    srcSet={`${getImageAttribute(props?.image, 'header_s', 'source_url')} 960w, ${getImageAttribute(props?.image, 'header_m', 'source_url')} 1280w, ${getImageAttribute(props?.image, 'header_l', 'source_url')} 1920w, ${getImageAttribute(props?.image, 'header_xl', 'source_url')} 2880w`}
                    sizes="100vw"
                  />
                }
              </div>
            </div>
          </InView>
          )
        }

        return null // This case would never happen


      }
    })
  }
}
